export const strContains = (string, substring) => {
  return string.indexOf(substring) !== -1;
}